import { ContainerType, Workflow } from '@apiContract';
import { getDateISOString } from './time';
import { SortingOrder } from 'src/types/contractHelpers';

export const getContainerTypeIdByWorkflow = (
  containerTypes: ContainerType[],
  workflow: Workflow,
): number => containerTypes.find((ct) => ct.workflow === workflow)?.id || 0;

export const getContainerDefaultValues = (containerTypes: ContainerType[], sortOrder: SortingOrder, workflow: Workflow) => ({
    containerTypeId: getContainerTypeIdByWorkflow(containerTypes, workflow),
    createdDate: workflow === Workflow.DateReceived ? getDateISOString(new Date()) : null,
    containerNumber: workflow === Workflow.Carrier ? 'USPS' : null,
    sortOrder,
  });
